<!-- CouponComponent.vue (Vue 2 兼容) -->
<template>
  <div class="coupon-container">
    <div class="coupon-group-name">{{config.moduleName}}</div>
    <div v-for="(coupon,index) in config.couponList">
      <div class="coupon-one" v-if="couponStyle === '1'">
        <div class="coupon-left">
          <div style="font-weight: 700"><span style="font-size: 12px">￥</span><span style="font-size: 18px">{{coupon.couponInfo.couponPrice}}</span></div>
          <div style="font-size: 12px">{{coupon.couponInfo.usePrice === 0 ? '无门槛' : `满${coupon.couponInfo.usePrice}元`}}</div>
        </div>
        <div class="coupon-right">
          <div style="font-size: 12px;margin-bottom: 5px">{{coupon.couponInfo.categoryLimit === '1' ? '部分商品可用' : '全场可用'}}</div>
          <el-button plain :type="getCoupon ? '' : 'danger' " size="mini" @click="getCoupon = !getCoupon">{{getCoupon ? '去使用' : '立刻领取'}}</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'CouponComponent',
  components: {

  },
  props: {
    config: {
      type: Object,
      default: () => ({
        moduleName: '限时抢好券',
        couponList: [
          {
            couponPrice: 10,
            usePrice: 0,
            categoryLimit: '1',
          }
        ]
      })
    },
    couponStyle: {
      type: String,
      default: '1'
    }
  },
  data() {
    return {
      getCoupon: false
    }
  },
  watch: {
    config: {
        handler(newVal) {
          console.log(newVal);
        },
        deep: true
      }
  },
  mounted() {
    console.log(this.config);
  },
  methods: {

  },
}
</script>

<style scoped>
.coupon-container{
  background-color: #ff2222;
  padding: 10px;
  border-radius: 10px;
}
.coupon-group-name{
  color: #fff;
  display: flex;
  justify-content: center;
  font-size: 20px;
  font-weight: 600;
}
.coupon-one{
  background-color: #fefefe;
  border-radius: 5px;
  padding: 10px;
  display: flex;
  margin-top: 10px;
}
.coupon-left{
  position: relative;
  border-right: dotted 1px #ff2222;
  padding: 0 20px 0 10px;
  color: #ff2222;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.coupon-left::before{
  content: '';
  position: absolute;
  right: -5px;
  top: -15px;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #ff2222;
}
.coupon-left::after{
  content: '';
  position: absolute;
  right: -5px;
  bottom: -15px;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #ff2222;
}
.coupon-right{
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/instrument/CouponComponent.vue